import ImageLoaderBase from './bfv-image-loader-base';
import { isScrolledInViewport, getWindowScroll } from '../../tools/helpers';
import { CONFIG } from '../config';

class BfvImage extends ImageLoaderBase {
  constructor(options = {}) {
    super(options);
  }

  init() {
    this.prepareDOM();
    this.bindEvents();

    if (!this.disableAutoLoad) {
      // dynamically load image on scroll
      setTimeout(() => this.loadImageVisibleInViewport(), 200);
    }
  }

  /**
   * OVERRIDES
   */

  callbackImageLoaded() {
  }

  /**
   * EVENT HANDLING
   */

  bindEvents() {
    window.addEventListener(CONFIG.events.VIEWPORT_SCROLL, (event) => {
      this.loadImageVisibleInViewport(event.detail.scroll);
    });

    // eslint-disable-next-line no-unused-vars
    window.addEventListener(CONFIG.events.VIEWPORT_CHANGED, () => {
      this.targetAsset = this.getTargetImageAsset(this.currentBreakpointKey);
      this.stateLoading = this.LOAD_INIT;
      this.loadImageVisibleInViewport();
    });

    if (this.disableAutoLoad) {
      this.$root.addEventListener(CONFIG.events.BFV_IMAGE_LOAD, () => {
        this.disableAutoLoad = false;
        this.targetAsset = this.getTargetImageAsset(this.currentBreakpointKey);
        this.stateLoading = this.LOAD_INIT;
        this.loadImageVisibleInViewport();
      });
    }
  }

  /**
   * IMAGE HANDLING
   */

  loadImageVisibleInViewport(windowScroll = getWindowScroll()) {
    /**
     * load image source when not already loaded and image will be visible in viewport
     */
    if (this.stateLoading === this.LOAD_INIT && !this.disableAutoLoad) {
      if (isScrolledInViewport(this.$root, windowScroll, 0.55)) {
        this.updateImageSource();
      }
    }
  }

  updateImageSource() {
    /**
     * load image as defined in data attribute
     */
    // load image source
    try {
      this.replaceImageSource(this.getImageSource());
      // @formatter:off
      // @note: i was forced to add try catch so that an missing image src does not crash all following images
    } catch (error) {
      console.warn(error);
    }
    // @formatter:on
  }

  getImageSource() {
    /**
     * get value from data attribute for image source url
     */
    const srcSmall = this.getAttributeSource(this.attrSource);
    const srcMedium = this.getAttributeSource(this.attrSourceMedium);
    const srcLarge = this.getAttributeSource(this.attrSourceLarge);

    if (this.targetAsset === 'large') {
      return srcLarge || srcMedium || srcSmall;
    } if (this.targetAsset === 'medium') {
      return srcMedium || srcSmall;
    }

    return srcSmall;
  }
}

export default BfvImage;
